import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { createFieldSelect } from "../../../../../components/input/template-builder/template-builder.logic";
import { createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { callUserStatus } from "../tab-4/tab4.section";
import { createFieldUserAuthorize } from "./tab5.section";

const AttachmentInlineList = defineAsyncComponent(() => import("../../../../../components/attachment/AttachmentInlineList"));

export const createColumns = () => {
    return [
        createColumnInput({
            title: () => i18n.global.t("views.company.mgt.tab.5.title"),
            dataIndex: "companyName",
            dataIndexValue: ({ record }) => (record.refPersonType?.key === "1" ? record.companyName : record.fullName),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.company.mgt.tab.5.docId"),
            dataIndex: "idCard",
            dataIndexValue: ({ record }) =>
                record.refPersonType?.key === "1"
                    ? `${i18n.global.t("views.register.idTax")} ${record.idCard}`
                    : `${record.refDocumentTypePerson?.value} ${record.idCard}`,
            customRender: ({ record }) => {
                if (record.refPersonType?.key === "1") {
                    return (
                        <div>
                            <div>{i18n.global.t("views.register.idTax")}</div>
                            <div>{record.idCard}</div>
                        </div>
                    );
                } else if (record.refPersonType?.key === "2") {
                    return (
                        <div>
                            <div>{record.refDocumentTypePerson?.value}</div>
                            <div>{record.idCard}</div>
                        </div>
                    );
                }
                return <div></div>;
            },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.user.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callUserStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
};

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refStatus`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.refStatus"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refStatus,
                            "onUpdate:value": value => (model.refStatus = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callUserStatus({ searchQuery }).then(items =>
                                    items.filter(item => ["active", "suspend", "archive"].includes(item.key))
                                ),
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            ...createFieldUserAuthorize({ props, data, key, isLoading }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}attachments`,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "AttachmentInlineList" } })
                    );
                    return <AttachmentInlineList {...componentProp}></AttachmentInlineList>;
                }
            }
        ]
    });
};
